import Component from '../../common/Component';
import ItemList from '../../common/utils/ItemList';
import classList from '../../common/utils/classList';
import Icon from '../../common/components/Icon';
export default class StatusWidgetItem extends Component {
  view() {
    return m("li", {
      className: classList('StatusWidgetItem', this.attrs.className)
    }, this.content());
  }

  /**
   * Build the main content of the status item.
   * Can be overridden to completely customize the layout.
   */
  content() {
    const {
      icon
    } = this.attrs;
    return m('[', null, icon && m("i", {
      className: icon
    }), m("div", {
      className: "StatusWidgetItem-content"
    }, this.labelView(), this.valueView()));
  }

  /**
   * Build an ItemList of the status item's contents.
   * Extensions can easily add, remove, or modify parts.
   */
  contentItems() {
    const items = new ItemList();
    items.add('icon', this.iconView(), 100);
    items.add('label', this.labelView(), 90);
    items.add('value', this.valueView(), 70);
    return items;
  }

  /**
   * Render the icon (if provided).
   */
  iconView() {
    const {
      icon
    } = this.attrs;
    if (!icon) return m('[', null);
    return m(Icon, {
      name: icon
    });
  }

  /**
   * Render the label.
   */
  labelView() {
    return m("strong", {
      className: "StatusWidgetItem-label"
    }, this.attrs.label);
  }

  /**
   * Render the value.
   */
  valueView() {
    return m("span", {
      className: "StatusWidgetItem-value"
    }, this.attrs.value);
  }
}
flarum.reg.add('core', 'admin/components/StatusWidgetItem', StatusWidgetItem);